// @ts-nocheck
export interface User {
  id: string;
  email: string;
  name: string;
  avatar_url: string;
  org_role: 'admin' | 'member';
  auth_method: 'google' | 'totp';
}

export interface OrgMember {
  user_id: string;
  email: string;
  name: string;
  avatar_url: string;
  role: 'admin' | 'member';
  can_share_external: number;
  joined_at: string;
}

export interface Invite {
  id: string;
  email: string;
  role: 'admin' | 'member';
  can_share_external: number;
  token: string;
  expires_at: string;
  accepted_at: string | null;
  created_at: string;
}

export interface Workspace {
  id: string;
  name: string;
  owner_id: string;
  created_at: string;
}

export interface Folder {
  id: string;
  workspace_id: string;
  name: string;
  position: number;
  created_by: string;
  created_at: string;
}

export interface Board {
  id: string;
  workspace_id: string;
  name: string;
  description: string;
  created_by: string;
  created_at: string;
  folder_id: string | null;
  is_private: number;
  is_favorite: number;
  is_archived: number;
  board_type: string;
}

export interface BoardShare {
  id: string;
  board_id: string;
  user_id: string | null;
  email: string;
  role: string;
  user_name?: string;
  avatar_url?: string;
  created_at: string;
}

export interface Group {
  id: string;
  board_id: string;
  name: string;
  color: string;
  position: number;
  collapsed: number;
}

export type ColumnType =
  | 'text'
  | 'status'
  | 'date'
  | 'numbers'
  | 'people'
  | 'dropdown'
  | 'checkbox'
  | 'email'
  | 'phone'
  | 'country'
  | 'priority'
  | 'timeline'
  | 'files'
  | 'formula'
  | 'website';

export interface Column {
  id: string;
  board_id: string;
  name: string;
  type: ColumnType;
  config: string;
  position: number;
  width: number;
}

export interface Item {
  id: string;
  group_id: string;
  board_id: string;
  name: string;
  position: number;
  created_by: string;
  created_at: string;
}

export interface CellValue {
  item_id: string;
  column_id: string;
  value: string;
}

export interface BoardData {
  board: Board;
  groups: Group[];
  columns: Column[];
  items: Item[];
  cells: CellValue[];
}

export const COLUMN_TYPE_INFO: Record<ColumnType, { label: string; icon: string; color: string; category: string }> = {
  status: { label: 'Status', icon: 'St', color: '#00c875', category: 'Essentials' },
  dropdown: { label: 'Dropdown', icon: 'Dd', color: '#a25ddc', category: 'Essentials' },
  text: { label: 'Text', icon: 'Tx', color: '#ff642e', category: 'Essentials' },
  date: { label: 'Date', icon: 'Dt', color: '#579bfc', category: 'Essentials' },
  people: { label: 'People', icon: 'Pe', color: '#ffcb00', category: 'Essentials' },
  numbers: { label: 'Numbers', icon: 'Nr', color: '#a25ddc', category: 'Essentials' },
  files: { label: 'Files', icon: 'Fi', color: '#ff642e', category: 'Super useful' },
  checkbox: { label: 'Checkbox', icon: 'Cb', color: '#00c875', category: 'Super useful' },
  formula: { label: 'Formula', icon: 'fx', color: '#ff642e', category: 'Super useful' },
  timeline: { label: 'Timeline', icon: 'Tl', color: '#579bfc', category: 'Super useful' },
  priority: { label: 'Priority', icon: 'Pr', color: '#ffcb00', category: 'Super useful' },
  email: { label: 'Email', icon: '@', color: '#579bfc', category: 'More columns' },
  phone: { label: 'Phone', icon: 'Ph', color: '#00c875', category: 'More columns' },
  country: { label: 'Country', icon: 'Co', color: '#a25ddc', category: 'More columns' },
  website: { label: 'Website', icon: '🔗', color: '#579bfc', category: 'More columns' },
};

export const GROUP_COLORS = [
  '#579bfc', '#a25ddc', '#e2445c', '#fdab3d', '#00c875',
  '#ff642e', '#ffcb00', '#c4c4c4', '#9aadbd', '#ff158a',
  '#037f4c', '#0086c0', '#bb3354', '#175a63', '#4eccc6',
];
